/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowTriggerEventProcessCompleteDto } from '../../models/workflow-trigger-event-process-complete-dto';

export interface AutomatedProcessGetTriggerEventProcessById$Params {
  id: number;
}

export function automatedProcessGetTriggerEventProcessById(http: HttpClient, rootUrl: string, params: AutomatedProcessGetTriggerEventProcessById$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventProcessCompleteDto>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessGetTriggerEventProcessById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkflowTriggerEventProcessCompleteDto>;
    })
  );
}

automatedProcessGetTriggerEventProcessById.PATH = '/automated-process/workflow-trigger/trigger-event-process/{id}';